import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { FREE, SINGILE_RIDE, DAILY_FREE, MONTHLY_FREE } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { TariffProfile } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/tariff-profile.interface';
import { Price } from 'src/app/modules/route-planner/interfaces/route-planning/price.interface';

@Component({
    selector: 'app-tariff-profile-price',
    templateUrl: './tariff-profile-price.component.html',
    styleUrls: ['./tariff-profile-price.component.scss'],
    standalone: false
})
export class TariffProfilePriceComponent {
  @Input() prices: Price[];
  @Input() selectedProfile: TariffProfile;
  @Input() isInHeader: boolean;

  freeText: string
  singleRideText: string
  dailyFreeText: string
  monthlyFreeText: string

  private currencyPipe = new CurrencyPipe('en');

  constructor(private readonly languageService: LanguageService) { }

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
  }

  formatPrice(value: number): string {
    return (this.currencyPipe.transform(value, 'ILS', 'symbol') || '').replace(/\s/g, '');
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.freeText = FREE[language.language]
      this.singleRideText = SINGILE_RIDE[language.language]
      this.dailyFreeText = DAILY_FREE[language.language]
      this.monthlyFreeText = MONTHLY_FREE[language.language]
    })
  }
}
